<template>
  <div class="contacts">
    <PageHeader>
      <template v-slot:actions>
        <b-button
          v-can="$permissions.WRITE_OTHER_CONTACT"
          @click="addContact"
          variant="primary"
        >
          <span class="d-none d-sm-inline">Lägg till</span>
          <i class="fas fa-plus"></i>
        </b-button>
      </template>
    </PageHeader>
    <ContactList mode="Contacts" />
  </div>
</template>

<script>
import PageHeader from "@/layouts/components/PageHeader.vue";
import ContactList from "@/components/ContactList.vue";
import { BButton } from "bootstrap-vue";

export default {
  components: {
    PageHeader,
    ContactList,
    BButton,
  },
  data() {
    return {
      searchQuery: null,
    };
  },
  methods: {
    addContact() {
      this.$store.dispatch("createContact").then((response) => {
        this.$router.push({
          name: "contact-add",
          params: { contactId: response.id, isNew: true },
        });
      });
    },
  },
};
</script>

<style scoped>
.ce-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 1px solid #ebe9f1;
  background: #fff;
}
.ce-list-item:last-child {
  border-bottom: none;
}
.ce-list-item-prefix {
  padding: 0.75rem 0;
}
.ce-list-item-desc {
  padding: 0.75rem 0 0.75rem 0.75rem;
}
.ce-list-item-action {
  padding: 0.75rem 0;
  min-width: 79px;
}
.ce-list-item-desc {
  margin-right: auto;
}
</style>
